import React from 'react';
import { companyInfo } from '../mock';

const Footer = () => {
  return (
    <footer 
      style={{
        background: '#000000',
        borderTop: '1px solid rgba(255, 255, 255, 0.25)',
        padding: '60px 7.6923% 40px',
        marginTop: '100px'
      }}
    >
      <div 
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '40px',
          marginBottom: '40px'
        }}
      >
        <div>
          <h3 
            style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#00FFD1',
              marginBottom: '8px',
              letterSpacing: '-0.02em'
            }}
          >
            Logardt Group KB
          </h3>
          <p 
            style={{
              fontSize: '14px',
              color: 'rgba(255, 255, 255, 0.7)',
              lineHeight: '1.5',
              margin: '0 0 4px 0'
            }}
          >
            Godkänd för F-skatt
          </p>
          <p 
            style={{
              fontSize: '14px',
              color: 'rgba(255, 255, 255, 0.7)',
              lineHeight: '1.5',
              margin: '0 0 16px 0'
            }}
          >
            Godkänd för moms
          </p>
          <p 
            style={{
              fontSize: '16px',
              color: 'rgba(255, 255, 255, 0.85)',
              lineHeight: '1.5',
              margin: 0
            }}
          >
            Consulting Services
          </p>
        </div>
        
        <div>
          <h4 
            style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#FFFFFF',
              marginBottom: '16px',
              letterSpacing: '-0.02em'
            }}
          >
            Get in Touch
          </h4>
          <p 
            style={{
              fontSize: '16px',
              color: 'rgba(255, 255, 255, 0.85)',
              margin: 0,
              lineHeight: '1.5'
            }}
          >
            Use the contact form above to reach us and we will get back to you shortly.
          </p>
        </div>
        
        <div>
          <h4 
            style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#FFFFFF',
              marginBottom: '16px',
              letterSpacing: '-0.02em'
            }}
          >
            Partners
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <p 
              style={{
                fontSize: '16px',
                color: 'rgba(255, 255, 255, 0.85)',
                margin: 0
              }}
            >
              Flowmingo AI
            </p>
          </div>
        </div>
      </div>
      
      <div 
        style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.25)',
          paddingTop: '24px',
          textAlign: 'center'
        }}
      >
        <p 
          style={{
            fontSize: '16px',
            color: '#4D4D4D',
            margin: 0
          }}
        >
          © {new Date().getFullYear()} Logardt Group. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
